<template>
    <form @submit.prevent="onSubmit">
        <div class="row">
            <div class="col-6">
                <input value="male" v-bind="formConfig.gender[0]" v-model="entry.gender" />
                <label for="gender-a" v-if="formConfig.gender[0].label">
                    <div class="indicator"></div>
                    {{ formConfig.gender[0].label }}
                </label>
            </div>
            <div class="col-6">
                <input value="female" v-bind="formConfig.gender[1]" v-model="entry.gender" />
                <label for="gender-b" v-if="formConfig.gender[1].label">
                    <div class="indicator"></div>
                    {{ formConfig.gender[1].label }}
                </label>
            </div>
        </div>
        <div class="row">
            <span class="error" v-if="errors.gender">{{ errors.gender[0] }}</span>
        </div>

        <div class="row">
            <div class="col-8">
                <label for="firstname">{{ formConfig.firstname.label }}</label>
                <input v-bind="formConfig.firstname" v-model="entry.firstname" />
                <span class="error" v-if="errors.firstname">{{ errors.firstname[0] }}</span>
            </div>
            <div class="col-4">
                <label for="infixname">{{ formConfig.infixname.label }}</label>
                <input v-bind="formConfig.infixname" v-model="entry.infixname" />
                <span class="error" v-if="errors.infixname">{{ errors.infixname[0] }}</span>
            </div>
        </div>

        <div class="row">
            <label for="surname">{{ formConfig.surname.label }}</label>
            <input v-bind="formConfig.surname" v-model="entry.surname" />
            <span class="error" v-if="errors.surname">{{ errors.surname[0] }}</span>
        </div>

        <span class="label">Geboortedatum</span>

        <div class="row">
            <div class="col-3">
                <!-- <label for="dayOfBirth">{{ formConfig.dayOfBirth.label }}</label> -->
                <input v-bind="formConfig.dayOfBirth" v-model="entry.dayOfBirth" />
                <span class="error" v-if="errors.dayOfBirth">{{ errors.dayOfBirth[0] }}</span>
            </div>
            <div class="col-3">

                <!-- <input v-bind="formConfig.monthOfBirth" v-model="entry.monthOfBirth" /> -->
                <select v-bind="formConfig.monthOfBirth" v-model="entry.monthOfBirth" :class="{ 'placeholder': entry.monthOfBirth === null }">
                    <option disabled selected="selected" :value="null">Maand</option>
                    <option v-for="( value, key ) of formConfig.monthOfBirth.options" :value="key">
                        {{ value }}
                    </option>
                </select>
                <span class="error" v-if="errors.monthOfBirth">{{ errors.monthOfBirth[0] }}</span>
            </div>
            <div class="col-6">
                <!-- <label for="yearOfBirth">{{ formConfig.yearOfBirth.label }}</label> -->
                <input v-bind="formConfig.yearOfBirth" v-model="entry.yearOfBirth" />
                <span class="error" v-if="errors.yearOfBirth">{{ errors.yearOfBirth[0] }}</span>
            </div>
        </div>
        <div class="row">
            <span class="error" v-if="errors.dateOfBirth && !errors.dayOfBirth && !errors.monthOfBirth && !errors.yearOfBirth">{{ errors.dateOfBirth[0] }}</span>
        </div>

        <div class="row">
            <div class="col-6">
                <label for="zipcode">{{ formConfig.zipcode.label }}</label>
                <input v-bind="formConfig.zipcode" @blur="checkAddress" v-model="entry.zipcode" />
                <span class="error" v-if="errors.zipcode">{{ errors.zipcode[0] }}</span>
            </div>

            <div class="col-3">
                <label for="house_num">{{ formConfig.house_num.label }}</label>
                <input v-bind="formConfig.house_num" @blur="checkAddress" v-model="entry.house_num" />
                <span class="error" v-if="errors.house_num">{{ errors.house_num[0] }}</span>
            </div>

            <div class="col-3">
                <label for="house_num_add">{{ formConfig.house_num_add.label }}</label>
                <input v-bind="formConfig.house_num_add" @blur="checkAddress" v-model="entry.house_num_add" />
                <span class="error" v-if="errors.house_num_add">{{ errors.house_num_add[0] }}</span>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <span class="error text-center" v-if="addressError" style="width: 100%; display:inline-block;">Adres niet gevonden.</span>
                <div class="address-preview"  v-if="( entry.street && entry.city ) || waitingForAddress">
                    <v-spinner v-if="waitingForAddress"></v-spinner>
                    <span v-if="entry.street && entry.city">{{ entry.street + ', ' + entry.city }}</span>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <label for="telephone">{{ formConfig.telephone.label }}</label>
                <input v-bind="formConfig.telephone" v-model="entry.telephone" />
                <span class="error" v-if="errors.telephone">{{ errors.telephone[0] }}</span>
                <p class="small">Vul je telefoonnummer in en ontvang eenmalig een telefonisch aanbod van Lotto om automatisch mee te spelen.</p>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <label for="emailaddress">{{ formConfig.emailaddress.label }}</label>
                <input v-bind="formConfig.emailaddress" v-model="entry.emailaddress" />
                <span class="error" v-if="errors.emailaddress">{{ errors.emailaddress[0] }}</span>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <input v-bind="formConfig.kit" v-model="entry.kit" />
                <label :for="formConfig.kit.id"><div class="indicator"></div> Ja, ik ontvang graag per e-mail interessante acties en aanbiedingen van Lotto.</label>
            </div>
        </div>

        <button type="submit" class="white" tabindex="50">Verstuur <v-spinner v-if="waitingForApi" stroke="#fff"></v-spinner></button>
    </form>
</template>

<style lang="scss" scoped>
    label, input, span{
        display:block;
        width:100%;
    }

    label[for^="gender"], label[for^="kit"], input[type="radio"], input[type="checkbox"]{
        display:inline-block;
        width:auto;
    }
</style>

<script>
    import Vue from 'vue';
    import Spinner from '@/app/components/Spinner';
    import { LottoConfig, fingerprintjs2, recaptcha } from '@/app/mixins';

    export default {
        components: {
            'v-spinner': Spinner
        },

        mixins: [ LottoConfig, fingerprintjs2, recaptcha ],

        data()
        {
            return {
                entry: {
                    gender: '',
                    firstname: '',
                    infixname: '',
                    surname: '',
                    zipcode: '',
                    dayOfBirth: null,
                    monthOfBirth: null,
                    yearOfBirth: null,
                    house_num: null,
                    house_num_add: '',
                    telephone: null,
                    emailaddress: '',
                    kit: false
                },

                waitingForApi: false,
                apiErrors: false,

                waitingForAddress: false,
                addressError: false,

                validatedOnce: false,

                errors: {

                }
            };
        },

        computed: {
            dateOfBirth()
            {
                return new Date( this.entry.yearOfBirth, this.entry.monthOfBirth, this.entry.dayOfBirth );
            },

            savedEntry()
            {
                if( this.$store.getters[ 'entry/all' ] )
                {
                    return this.$store.getters[ 'entry/all' ];
                }

                return false;
            },

            numCorrect()
            {
                return this.$store.getters.getCorrectAnswers.length;
            }
        },

        watch: {
            dateOfBirth: function( pVal )
            {
                this.entry.dateOfBirth = pVal;
            },

            'entry.telephone': function( pVal )
            {
                pVal = pVal.replace( /[-\s]/g, '' );

                pVal = pVal.replace( /^(\+31)/g, '0' );
                pVal = pVal.replace( /^(0031)/g, '0' );

                this.entry.telephone = pVal;
            },

            entry: {
                deep: true,
                handler( pVal )
                {
                    if( this.validatedOnce )
                    {
                        this.validate();
                    }
                }
            }
        },

        beforeCreate()
        {
        },

        beforeDestroy()
        {
            // save if route away
            this.$store.dispatch( 'entry/merge', this.entry );
        },

        mounted()
        {
            // load entry if there is any
            if( this.savedEntry )
            {
                this.entry = Object.assign( this.entry, this.savedEntry );
            }
        },

        methods: {
            checkAddress( e )
            {
                // this.stripSpaces( e );
                if( this.lastAddress === this.entry.zipcode + this.entry.house_num + this.entry.house_num_add )
                {
                    return;
                }
                if( !this.entry.house_num )
                {
                    return;
                }

                this.addressError = false;
                this.lastAddress = this.entry.zipcode + this.entry.house_num + this.entry.house_num_add;
                if( this.entry.zipcode.length > 5 && this.entry.house_num.length > 0 )
                {
                    let url = window._rootData.apiUrl + '/api/address/' + this.entry.zipcode + '/' + this.entry.house_num;
                    if( this.entry.house_num_add.length > 0 )
                    {
                        url += '/' + this.entry.house_num_add;
                    }
                    this.waitingForAddress = true;
                    Vue.$http.post( url ).then( ( result ) =>
                    {
                        if( result.data.errorCode )
                        {
                            throw new Error( result.data.message );
                        }
                        this.entry.street = result.data.street;
                        this.entry.city = result.data.city;
                        this.waitingForAddress = false;
                    }).catch( ( result ) =>
                    {
                        this.addressError = true;
                        this.entry.street = null;
                        this.entry.city = null;
                        this.waitingForAddress = false;
                    });
                }
            },

            async validate()
            {
                this.validatedOnce = true;

                return this.validationSchema.validate( this.entry, { abortEarly: false })
                    .then( isValid =>
                    {
                        this.errors = {};
                    })
                    .catch( error =>
                    {
                        for( let item in this.entry )
                        {
                            this.errors[ item ] = [];
                        }

                        for( let err of error.inner )
                        {
                            if( !this.errors[ err.path ] )
                            {
                                this.errors[ err.path ] = [];
                            }

                            this.errors[ err.path ].push( err.errors[ 0 ] );
                        }

                        this.$forceUpdate();

                        // this.scrollToError();
                    });
            },

            async onSubmit()
            {
                if( this.waitingForApi )
                {
                    return;
                }

                this.apiErrors = false;
                this.errors = {};

                await this.validate();

                if( Object.keys( this.errors ).length === 0 )
                {
                    this.entry['origin'] = window._rootData.r;
                    this.entry['g-recaptcha-response'] = await this.executeRecaptcha();

                    this.entry['date_of_birth'] = this.dateOfBirth.toISOString().substring( 0, 10 );
                    this.entry['num_correct'] = this.numCorrect;

                    this.waitingForApi = true;

                    this.$store.dispatch( 'entry/save', this.entry )
                        .then( result =>
                        {
                            this.waitingForApi = false;
                            this.$emit( 'formComplete' ); // ?
                        })
                        .catch( errors =>
                        {
                            this.waitingForApi = false;
                            this.apiErrors = true;
                        });
                }
            }

            // scrollToError()
            // {
            //     let elem = this.$el.querySelector( 'span.error' );
            //     if( !elem )
            //     {
            //         return;
            //     }

            //     let target = elem.getBoundingClientRect().top + window.pageYOffset;
            //     TweenMax.to( 'body,html', 1, { scrollTop: target - 100 });
            // }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/components/Form.vue